import PropTypes from "prop-types"

import { Panel } from "areas/cart/components"
import Media from "components/ui/media"
import { IS_JEWLR } from "helpers/application"
import { freeGiftPromoEnabled } from "helpers/holiday"

import Help from "./help-footer"
import OrderSummary from "./order-summary"
import PromoCode from "./promo-code"

const SidePanel = ({ cartSummaryRef }) => {
  return (
    <aside className="desktop:h-full desktop:sticky desktop:top-24 desktop:w-1/3 w-full">
      {freeGiftPromoEnabled() ? (
        <Media greaterThanOrEqual="tablet">
          <Panel className="tablet:py-24">
            <PromoCode />
          </Panel>
        </Media>
      ) : (
        <Panel className="tablet:py-24">
          <PromoCode />
        </Panel>
      )}
      <OrderSummary cartSummaryRef={cartSummaryRef} />
      {IS_JEWLR() && (
        <Media greaterThanOrEqual="tablet">
          <Help />
        </Media>
      )}
    </aside>
  )
}

SidePanel.propTypes = {
  cartSummaryRef: PropTypes.object,
}

export default SidePanel
